import regeneratorRuntime from "regenerator-runtime";

const CropperComponent = {
  mounted() {
    this._me = this
    this._el = this.el
    this._settings = this.el.dataset
    this._extractAndSendImageData = this._extractAndSendImageData.bind(this)
    this._getComponents().then( (Cropper) => {
      this._Cropper = Cropper
      this._installCropper()
    })
    this.handleEvent("get_cropped_canvas", this._extractAndSendImageData)
  },
  destroyed(){
    this.cropperInst.destroy()
  },

  _installCropper(){
    const image = this._el.querySelector('img');
    let self = this;
    setTimeout( () => {
      window.croppers = window.croppers || []
      let options = this._getCropOptions()
      const cropper = new this._Cropper(image, {
        ...options,
        crop(event) { self._updatePreview(event) },
        ready(event){ self._maybeAddRoundedCrop.bind(self)() }
      })
      croppers.push(cropper)
      self.cropperInst = cropper
    }, 200)
  },
  _updatePreview(event) {
    this._me.pushEventTo(this._el, "update-crop", {id: this._el.id, detail: event.detail}, (reply, ref) => {})
  },

  _getCropOptions() {
    let defaults = {
      aspectRatio: 9 / 16,
      scalable: false,
      zoomable: false
    }
    let options = Object.assign(defaults, this._settings)
    return options;
  },

  _maybeAddRoundedCrop() {
    if ( this._settings["circleCrop"] == "true" ) {
      this.el
        .querySelector(".cropper-view-box")
        .classList
        .add("rounded-full")
    }
  },

  _extractAndSendImageData() {
    this.cropperInst.getCroppedCanvas().toBlob( (blob) => {
      blob.arrayBuffer().then((buffer) => {
        const reader = new FileReader();

        reader.onload = (event) => {
          const dataUrl = event.target.result;
          const [_, base64String] = dataUrl.split(',');
          this.pushEventTo(`#${this.el.id}`,"save_blob", {base64String})
        };

        reader.readAsDataURL(blob)
      })
    })
  },

  async _getComponents() {
    const {default: Cropper} = await import('cropperjs')
    await import('cropperjs/dist/cropper.min.css')
    return Cropper
  }

}

export default { CropperComponent }
